$('.page-content.duvidas .m-qa .item .question').click(function(event) {
	var t = $(this).parent();
	t.toggleClass('is-active');
	CNET.FooterCheck();
});